import { CalendarFunctions as calFns } from "../../../components/Calendar";
import { ILabRecord } from "../../../interfaces/Lab";

const GroupLabsByDate = (labs: ILabRecord[]): { [key: string]: ILabRecord[] } => {
  const sortedLabs = labs.sort(
    (a, b) => new Date(b.labCreatedTime).getTime() - new Date(a.labCreatedTime).getTime()
  );
  return sortedLabs.reduce((acc, lab) => {
    const { labCreatedTime } = lab;
    const groupKey = calFns.convertADtoBS(new Date(labCreatedTime)).formatted5;
    const newAcc = { ...acc };
    if (!newAcc[groupKey]) {
      newAcc[groupKey] = [];
    }
    newAcc[groupKey].push(lab);
    return newAcc;
  }, {} as { [key: string]: ILabRecord[] });
};

export default GroupLabsByDate;
